var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"backButton",attrs:{"src":require("@/assets/Arrow_Right.svg")},on:{"click":_vm.GoBack}})])}
var staticRenderFns = []

export { render, staticRenderFns }